import fetcher from "@/libs/fetcher";
import { useAuthStore } from "@/stores/authStore";
import useSWR from "swr";
import { shallow } from "zustand/shallow";

/**
 * สถานะช่องทางเติมเงินทรูมันนี่ (อัพสลิป → ตรวจอัตโนมัติ)
 *
 * หน้าฝากใช้ตัวนี้ตัดสินว่าจะโชว์แท็บทรูมันนี่แบบอัตโนมัติไหม
 * `enabled` มาจาก server — ถ้ายังไม่ได้ตั้ง TRUEWALLET_TOPUP_API_KEY จะเป็น false
 * แล้วหน้าฝากจะถอยไปใช้แบบเดิม (คัดลอกเบอร์ไปโอนเอง) แทน
 */

export const TRUEWALLET_TOPUP_PATH = "/api/topup-truewallet";

type TruewalletTopupRow = {
  id: string;
  status: "pending" | "verified" | "approved" | "rejected";
  amount: number | null;
};

type TruewalletTopupResponse = {
  enabled?: boolean;
  wallet_mobile?: string;
  bank_enabled?: boolean;
  promptpay_id?: string;
  data?: TruewalletTopupRow[];
};

type UseTruewalletTopupReturn = {
  /** พร้อมใช้จริง — ตั้งคีย์แล้ว และมีเบอร์วอลเล็ทให้โอน */
  enabled: boolean;
  walletMobile: string;
  /** เปิดช่องโอนจากธนาคารเข้าวอลเล็ท (พร้อมเพย์) ในหลังบ้านไว้ */
  bankEnabled: boolean;
  /** เบอร์หรือ e-Wallet ID ที่ใช้สร้าง QR พร้อมเพย์ */
  promptpayId: string;
  isLoading: boolean;
};

export default function useTruewalletTopup(): UseTruewalletTopupReturn {
  const [user] = useAuthStore((state) => [state.user], shallow);
  const { data, error } = useSWR<TruewalletTopupResponse>(
    user ? TRUEWALLET_TOPUP_PATH : null,
    (url: string) => fetcher<TruewalletTopupResponse>(url),
    { revalidateOnFocus: false, dedupingInterval: 60_000, shouldRetryOnError: false }
  );

  const walletMobile = data?.wallet_mobile ?? "";
  return {
    enabled: Boolean(data?.enabled) && Boolean(walletMobile),
    walletMobile,
    bankEnabled: Boolean(data?.bank_enabled),
    // ไม่ถอยไปใช้เบอร์เปล่า — พร้อมเพย์ของทรูต้องเป็น e-Wallet ID ไม่งั้น QR ผิดปลายทาง
    promptpayId: data?.promptpay_id ?? "",
    isLoading: !error && !data && Boolean(user),
  };
}
